export const CUSTOMER_FEEDBACK = 'CustomerFeedback';
export const DEPENDENT_TABLES = <const>['CustomerFeedback'];
export const DMS_MODULE = 'Servis';
